/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AcceptReservationPathParameters } from 'api/actions/accept-reservation/accept-reservation-path-parameters';
import { AcceptReservationResponse } from 'api/actions/accept-reservation/accept-reservation-response';

type AcceptReservationQueryParameters = Record<string, any>;

/**
 * The path of the AcceptReservation action.
 */
export const acceptReservationActionPath = new SweetPath<keyof AcceptReservationPathParameters>(
  '/admin/custom/reservations/{reservationId}/accept',
  { path: '{param}' }
);

/**
 * Creates a contextualized AcceptReservation actions.
 */
export default function createAcceptReservationAction(axios: AxiosInstance) {
  return function acceptReservationAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AcceptReservationPathParameters;
    query?: AcceptReservationQueryParameters;
  }) {
    const path = acceptReservationActionPath.insert(parameters);

    return axios.post<AcceptReservationResponse, AcceptReservationResponse>(path, { params: query, headers });
  };
}
